<template>
  <div>
    <div ref="galleryScrollTrigger"></div>
    <div class="ibox select-services-dropdown">
      <div
        class="ibox-content mobile-service-ibox-content p-left-15 p-right-15 add_padding_mop_common"
        style="border: none"
      >
        <div class="row">
          <div class="col-xs-9" style="padding-top: 5px">
            <span class="select-services-dropdown-title"
              >Photos & Attachments
            </span>
          </div>
          <div class="col-xs-3">
            <div class="dropdown" style="float: right">
              <button
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="actions-btn btn btn-default three-dots-btn gh_customer_name dropdown-toggle"
              >
                <i
                  class="fa fa-ellipsis-v"
                  style="color: rgba(138, 138, 138, 1); font-size: 18px"
                ></i>
              </button>
              <ul
                class="dropdown-menu dropdownActionsMenuCusList pair_of_all_li"
                aria-labelledby="photosDropDonwActionsMenu"
                style="z-index: 99999998; margin-left: -300px; top: 20px"
                id="photosActionsMenuByHover"
              >
                <li v-if="type == 'booking' || type == 'inquiry'">
                  <a
                    class="a_link"
                    id="booking_add_attachments_button"
                    data-target="#addPhotosAttachments_modal"
                    data-toggle="modal"
                    href="javascript:void(0)"
                    @click="resetAddPhotoAndAttachmentModal('1')"
                  >
                    <span><i class="fa fa-camera"></i></span>
                    <span>Add Photos</span>
                  </a>
                </li>
                <li v-if="type == 'booking' || type == 'inquiry'">
                  <a
                    class="a_link"
                    id="booking_add_attachments_button"
                    data-target="#addPhotosAttachments_modal"
                    data-toggle="modal"
                    href="javascript:void(0)"
                    @click="resetAddPhotoAndAttachmentModal('2')"
                  >
                    <span><i class="fa fa-camera"></i></span>
                    <span>Add Attachments</span>
                  </a>
                </li>
                <li v-if="type != 'booking' && type != 'inquiry'">
                  <a
                    class="a_link"
                    id="booking_add_photos_button"
                    data-toggle="modal"
                    data-target="#popupi"
                    href="#"
                    @click="showPopUp"
                  >
                    <span><i class="fa fa-camera"></i></span>
                    <span>Add Photos</span>
                  </a>
                </li>

                <!--                        <li v-if="type == 'booking'">-->
                <!--                             <a class="black_color upper" href="javascript:void(0)" data-toggle="modal" data-target="#popupi"  @click="uploadAttachment" ><span class="fa fa-upload"></span> <span>Upload Files</span></a>-->
                <!--                        </li>-->
                <li class="email" v-if="!fromInquiry" >
                  <a
                    v-if="!fromInquiry && (canSeeCustomer || loggedUserRole  != 'contractor')"
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click="EmailPhotosToCustomer"
                  >
                    <span><i class="fa fa-envelope"></i></span>
                    <span>Email Photos To Customer</span>
                  </a>

                  <a
                    href="javascript:void(0)"
                    v-if="itemType != 'complaint'"
                    data-toggle="modal"
                    data-target="#fn_nearest"
                    @click="sendEmailToContractor"
                  >
                    <span><i class="fa fa-envelope"></i></span>
                    <span>Email Photos To {{ singularWorkerName }} </span>
                  </a>
                </li>
                <li class="" v-if="canSeeCustomer || loggedUserRole  != 'contractor'">
                  <a
                    href="#"
                    @click="RequestPhotos"
                    data-toggle="modal"
                    data-target="#popupi"
                  >
                    <span><i class="fa fa-envelope"></i></span>
                    <span>Request Photos By Email</span>
                  </a>
                </li>
                <li class="" v-if="canSeeCustomer || loggedUserRole  != 'contractor'">
                  <a
                    href="#"
                    @click="RequestPhotosBySMS"
                    data-toggle="modal"
                    data-target="#popupi"
                    style="display: flex"
                  >
                    <span style="display: flex">
                      <svg
                        width="20"
                        height="15"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 0H2C0.9 0 0 0.9 0 2V20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H3.17L2 15.17V2H18V14Z"
                          fill="#2E4051"
                        />
                        <path
                          d="M6.39941 9.20801C6.39941 9.13184 6.3877 9.06348 6.36426 9.00293C6.34277 8.94043 6.30176 8.88379 6.24121 8.83301C6.18066 8.78027 6.0957 8.72852 5.98633 8.67773C5.87695 8.62695 5.73535 8.57422 5.56152 8.51953C5.36816 8.45703 5.18457 8.38672 5.01074 8.30859C4.83887 8.23047 4.68652 8.13965 4.55371 8.03613C4.42285 7.93066 4.31934 7.80859 4.24316 7.66992C4.16895 7.53125 4.13184 7.37012 4.13184 7.18652C4.13184 7.00879 4.1709 6.84766 4.24902 6.70312C4.32715 6.55664 4.43652 6.43164 4.57715 6.32812C4.71777 6.22266 4.88379 6.1416 5.0752 6.08496C5.26855 6.02832 5.48047 6 5.71094 6C6.02539 6 6.2998 6.05664 6.53418 6.16992C6.76855 6.2832 6.9502 6.43848 7.0791 6.63574C7.20996 6.83301 7.27539 7.05859 7.27539 7.3125H6.40234C6.40234 7.1875 6.37598 7.07812 6.32324 6.98438C6.27246 6.88867 6.19434 6.81348 6.08887 6.75879C5.98535 6.7041 5.85449 6.67676 5.69629 6.67676C5.54395 6.67676 5.41699 6.7002 5.31543 6.74707C5.21387 6.79199 5.1377 6.85352 5.08691 6.93164C5.03613 7.00781 5.01074 7.09375 5.01074 7.18945C5.01074 7.26172 5.02832 7.32715 5.06348 7.38574C5.10059 7.44434 5.15527 7.49902 5.22754 7.5498C5.2998 7.60059 5.38867 7.64844 5.49414 7.69336C5.59961 7.73828 5.72168 7.78223 5.86035 7.8252C6.09277 7.89551 6.29688 7.97461 6.47266 8.0625C6.65039 8.15039 6.79883 8.24902 6.91797 8.3584C7.03711 8.46777 7.12695 8.5918 7.1875 8.73047C7.24805 8.86914 7.27832 9.02637 7.27832 9.20215C7.27832 9.3877 7.24219 9.55371 7.16992 9.7002C7.09766 9.84668 6.99316 9.9707 6.85645 10.0723C6.71973 10.1738 6.55664 10.251 6.36719 10.3037C6.17773 10.3564 5.96582 10.3828 5.73145 10.3828C5.52051 10.3828 5.3125 10.3555 5.10742 10.3008C4.90234 10.2441 4.71582 10.1592 4.54785 10.0459C4.38184 9.93262 4.24902 9.78809 4.14941 9.6123C4.0498 9.43652 4 9.22852 4 8.98828H4.88184C4.88184 9.12109 4.90234 9.2334 4.94336 9.3252C4.98438 9.41699 5.04199 9.49121 5.11621 9.54785C5.19238 9.60449 5.28223 9.64551 5.38574 9.6709C5.49121 9.69629 5.60645 9.70898 5.73145 9.70898C5.88379 9.70898 6.00879 9.6875 6.10645 9.64453C6.20605 9.60156 6.2793 9.54199 6.32617 9.46582C6.375 9.38965 6.39941 9.30371 6.39941 9.20801Z"
                          fill="#2E4051"
                        />
                        <path
                          d="M8.27734 6.05859H9.02148L10.1172 9.19043L11.2129 6.05859H11.957L10.416 10.3242H9.81836L8.27734 6.05859ZM7.87598 6.05859H8.61719L8.75195 9.11133V10.3242H7.87598V6.05859ZM11.6172 6.05859H12.3613V10.3242H11.4824V9.11133L11.6172 6.05859Z"
                          fill="#2E4051"
                        />
                        <path
                          d="M15.3525 9.20801C15.3525 9.13184 15.3408 9.06348 15.3174 9.00293C15.2959 8.94043 15.2549 8.88379 15.1943 8.83301C15.1338 8.78027 15.0488 8.72852 14.9395 8.67773C14.8301 8.62695 14.6885 8.57422 14.5146 8.51953C14.3213 8.45703 14.1377 8.38672 13.9639 8.30859C13.792 8.23047 13.6396 8.13965 13.5068 8.03613C13.376 7.93066 13.2725 7.80859 13.1963 7.66992C13.1221 7.53125 13.085 7.37012 13.085 7.18652C13.085 7.00879 13.124 6.84766 13.2021 6.70312C13.2803 6.55664 13.3896 6.43164 13.5303 6.32812C13.6709 6.22266 13.8369 6.1416 14.0283 6.08496C14.2217 6.02832 14.4336 6 14.6641 6C14.9785 6 15.2529 6.05664 15.4873 6.16992C15.7217 6.2832 15.9033 6.43848 16.0322 6.63574C16.1631 6.83301 16.2285 7.05859 16.2285 7.3125H15.3555C15.3555 7.1875 15.3291 7.07812 15.2764 6.98438C15.2256 6.88867 15.1475 6.81348 15.042 6.75879C14.9385 6.7041 14.8076 6.67676 14.6494 6.67676C14.4971 6.67676 14.3701 6.7002 14.2686 6.74707C14.167 6.79199 14.0908 6.85352 14.04 6.93164C13.9893 7.00781 13.9639 7.09375 13.9639 7.18945C13.9639 7.26172 13.9814 7.32715 14.0166 7.38574C14.0537 7.44434 14.1084 7.49902 14.1807 7.5498C14.2529 7.60059 14.3418 7.64844 14.4473 7.69336C14.5527 7.73828 14.6748 7.78223 14.8135 7.8252C15.0459 7.89551 15.25 7.97461 15.4258 8.0625C15.6035 8.15039 15.752 8.24902 15.8711 8.3584C15.9902 8.46777 16.0801 8.5918 16.1406 8.73047C16.2012 8.86914 16.2314 9.02637 16.2314 9.20215C16.2314 9.3877 16.1953 9.55371 16.123 9.7002C16.0508 9.84668 15.9463 9.9707 15.8096 10.0723C15.6729 10.1738 15.5098 10.251 15.3203 10.3037C15.1309 10.3564 14.9189 10.3828 14.6846 10.3828C14.4736 10.3828 14.2656 10.3555 14.0605 10.3008C13.8555 10.2441 13.6689 10.1592 13.501 10.0459C13.335 9.93262 13.2021 9.78809 13.1025 9.6123C13.0029 9.43652 12.9531 9.22852 12.9531 8.98828H13.835C13.835 9.12109 13.8555 9.2334 13.8965 9.3252C13.9375 9.41699 13.9951 9.49121 14.0693 9.54785C14.1455 9.60449 14.2354 9.64551 14.3389 9.6709C14.4443 9.69629 14.5596 9.70898 14.6846 9.70898C14.8369 9.70898 14.9619 9.6875 15.0596 9.64453C15.1592 9.60156 15.2324 9.54199 15.2793 9.46582C15.3281 9.38965 15.3525 9.30371 15.3525 9.20801Z"
                          fill="#2E4051"
                        />
                      </svg>
                    </span>
                    <span>Request Photos By SMS</span>
                  </a>
                </li>
                <li class="" v-if="fromBooking">
                  <a :href="photosLink" target="_blank">
                    <span><i class="fa fa-eye"></i></span>
                    <span>View all photos</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div style="display: block">
          <div
            class="add_photo_button dropdown"
            v-if="
              type == 'booking' ||
              type == 'invoice' ||
              type == 'estimate' ||
              type == 'inquiry'
            "
          >
            <button
              id="addAttachment_dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="actions-btn btn btn-default three-dots-btn gh_customer_name dropdown-toggle"
            >
              <i class="fa fa-upload fa-4x"></i><br />
              <span> Add Files </span>
            </button>
            <ul
              class="dropdown-menu dropdownActionsMenuCusList pair_of_all_li"
              aria-labelledby="photosDropDonwActionsMenu"
              style="z-index: 99999998; top: 20px"
              id=""
            >
              <li
                v-if="
                  type == 'booking' ||
                  type == 'invoice' ||
                  type == 'estimate' ||
                  type == 'inquiry'
                "
              >
                <a
                  class="a_link"
                  data-target="#addPhotosAttachments_modal"
                  data-toggle="modal"
                  href="javascript:void(0)"
                  @click="resetAddPhotoAndAttachmentModal('1')"
                >
                  <span><i class="fa fa-camera"></i></span>
                  <span>Add Photo</span>
                </a>
                <a
                  class="a_link"
                  data-target="#addPhotosAttachments_modal"
                  data-toggle="modal"
                  href="javascript:void(0)"
                  @click="resetAddPhotoAndAttachmentModal('2')"
                >
                  <span><i class="fa fa-camera"></i></span>
                  <span>Add Attachments</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="add_photo_button" v-else>
            <a
              style="margin-top: 30%; display: block"
              class="a_link"
              data-toggle="modal"
              data-target="#popupi"
              href="#"
              @click="showPopUp"
            >
              <i class="fa fa-camera fa-4x"></i><br />
              Add Photos
            </a>
          </div>
        </div>

        <!--                :src="photo.image_path"-->

        <div v-if="photos.length > 0">
          <ul class="product-gallery text-left">
            <li
              v-for="(photo, index) of photos"
              class="hover-effect"
              :key="index"
            >
              <img
                v-if="
                  photo.type == 'image' ||
                  photo.type == 'jpg' ||
                  photo.type == 'jpeg' ||
                  photo.type == 'png'
                "
                class="img-responsive"
                :class="{ is_deleted: true }"
                :id="`img-${index}`"
                :orignal="photo.compressed_path"
              />
              <div v-else class="img-responsive not-image-text">
                <span v-if="photo.type != ''">
                  {{ photo.type.toUpperCase() }}
                </span>
              </div>

              <div
                class="overlay"
                v-if="!photo.is_deleted && photo.type == 'image'"
                data-toggle="modal"
                data-target="#fn_nearest"
                @click="popuiWithParam(photo.index, photo.attachment_id)"
              >
                <a
                  style="
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    text-decoration: none;
                  "
                >
                  <h2 style="cursor: pointer">{{ imageMessage(photo) }}</h2>
                </a>
              </div>
              <div class="overlay" v-else-if="photo.type != 'image'">
                <a
                  v-if="credentials.can_download_files"
                  :href="photo.image_path"
                  target="_blank"
                  class="overlay-text"
                >
                  <h2>Download</h2>
                </a>
                <a v-else href="javascript:void(0)" class="overlay-text">
                  <h2>Don't have permission to download</h2>
                </a>
              </div>
              <div class="overlay" v-else>
                <a
                  :href="restoreImageLink.replace('image_ID', photo.image_id)"
                  class="overlay-text"
                >
                  <h2>{{ imageMessage(photo) }}</h2>
                </a>
              </div>
            </li>
          </ul>
        </div>

        <div style="clear: both"></div>
        <div style="width: 100%; text-align: center" v-show="!noMorePages">
          <a
            href="javascript:"
            class="btn btn-primary m-t see-more-size"
            @click="loadMore"
            >Load More</a
          >
        </div>
        <div style="clear: both"></div>

        <!--                load the add photo and attachment popup -->
        <add-photo-attachments-modal
          :type="type"
          :item-id="itemId"
          :have-images="haveImages"
          :add-photos-and-attachments-params="addPhotosAndAttachmentsParams"
        ></add-photo-attachments-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhotos } from "@/modules/common/api";
import AddPhotoAttachmentsModal from "./addPhotoAttachmentsModal";
import { EventBus } from "../../../../events/event-bus";

export default {
  name: "gallery",
  components: { AddPhotoAttachmentsModal },
  data() {
    return {
      photos: [],
      pagesLoaded: 2,
      noMorePages: false,
      credentials: [],
      scrollTrigger: null,
      imageLoaded: false,
    };
  },
  props: {
    addPhotosLink: {
      type: String,
    },
    photosLink: {
      type: String,
    },
    restoreImageLink: {
      type: String,
    },
    photosApi: {
      type: String,
    },
    itemType: {
      type: String,
    },
    itemId: 0,
    singularWorkerName: {
      type: String,
      default() {
        return "";
      },
    },
    canSeeCustomer: null,
    loggedUserRole: null,
    fromInquiry: "",
    fromBooking: "",
    invoiceId: "",
    customerId: "",
    type: 0,
    images: {},
    haveImages: 0,
    addPhotosAndAttachmentsParams: {},
  },
  created() {
    let vm = this;

    if (this.haveImages) {
      this.photos = this.images.photos;
      this.credentials = this.images.credentials;

      if (this.images.photos_count <= this.photos.length) {
        this.noMorePages = true;
      }
      if (vm.itemType != "booking") {
        window.setTimeout(function () {
          vm.showImages();
        }, 100);
      }
    } else {
      //add show deleted = 0 as filter to prevent view soft deleted images
      getPhotos(this.photosApi + "?show_deleted=0&show_attachments=1")().then(
        function (response) {
          vm.photos = response.data.photos;
          vm.credentials = response.data.credentials;

          if (response.data.photos_count <= vm.photos.length) {
            vm.noMorePages = true;
          }
          if (vm.itemType != "booking") {
            window.setTimeout(function () {
              vm.showImages();
            }, 100);
          }
        }
      );
    }
  },
  mounted() {
    this.scrollTrigger = this.$refs.galleryScrollTrigger;
    window.addEventListener("scroll", this.loadImageOnScroll);

    EventBus.$on("photoAttachmentUploaded", () => {
      $("#addPhotosAttachments_modal").modal("hide");
      let vm = this;
      vm.pagesLoaded = 2;
      //add show deleted = 0 as filter to prevent view soft deleted images
      getPhotos(this.photosApi + `?show_deleted=0&show_attachments=1`)()
        .then(function (response) {
          vm.photos = response.data.photos;
          vm.credentials = response.data.credentials;

          if (response.data.photos_count <= vm.photos.length) {
            vm.noMorePages = true;
          } else {
            vm.noMorePages = false;
          }
        })
        .then(function (response) {
          vm.showImages();
        });
    });
  },
  methods: {
    showImages() {
      let photos = this.photos;
      for (let i = 0; i < photos.length; i++) {
        $("#img-" + i).attr("src", photos[i].image_path);
      }
    },
    loadImageOnScroll() {
      if (!this.imageLoaded && this.isScrolledIntoView(this.scrollTrigger)) {
        this.imageLoaded = true;
        this.showImages();
      }
    },
    isScrolledIntoView(elem) {
      var docViewTop = window.pageYOffset;
      var docViewBottom = docViewTop + window.innerHeight;
      var elemTop = elem.offsetTop;
      return elemTop <= docViewBottom;
    },
    uploadAttachment() {
      let url = `/file_upload/booking/${this.itemId}?segment=${this.type}&type=${this.type}`;
      window.popupi("Upload Files", url);
    },
    showPopUp() {
      window.popupi("Add Photos", this.addPhotosLink);
    },
    popuiWithParam(index, attachment_id = 0) {
      window.fn_popupi_with_parm(
        "Discussion Gallery",
        `/default/slider/${this.itemId}/${index}/${this.itemType}?show_deleted=0&attachment_id=${attachment_id}`
      );
    },
    imageMessage(photo) {
      if (photo.is_deleted) return "Restore Image";

      if (photo.service_name != "") return photo.service_name;

      return "Show Image";
    },
    loadMore() {
      let vm = this;
      if (!this.noMorePages) {
        //add show deleted = 0 as filter to prevent view soft deleted images
        getPhotos(
          this.photosApi + `?show_deleted=0&current_page=${this.pagesLoaded}`
        )()
          .then(function (response) {
            console.log("Momen", response.data.photos_count, vm.photos.length);
            vm.photos = vm.photos.concat(response.data.photos);
            if (
              response.data.photos_count <= vm.photos.length ||
              response.data.photos.length == 0
            ) {
              vm.noMorePages = true;
            }
          })
          .then(function (response) {
            vm.showImages();
          });
        this.pagesLoaded++;
      }
    },
    emailPopupi(title, type) {
      let domain = window.location.origin;
      let url = `${domain}/email/photos/${this.itemId}/${type}`;
      window.popupi(title, url, false, false, true);
    },
    EmailPhotosToCustomer() {
      window.popupi(
        "Send Photos",
        `/get-canned-responses-form/customer/email/${this.itemType}/${this.itemId}/${this.customerId}/send_booking_photos`
      );
    },
    RequestPhotos() {
      window.popupi(
        "Request Photos",
        `/get-canned-responses-form/customer/email/${this.itemType}/${this.itemId}/${this.customerId}/photo_request`
      );
    },
    RequestPhotosBySMS() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Request Photos",
          `/get-canned-responses-form/customer/sms/${this.itemType}/${this.itemId}/${this.customerId}/Inquiry+Photo+Request`
        );
      } else {
        window.popupi(
          "Request Photos",
          `/get-canned-responses-form/customer/sms/${this.itemType}/${this.itemId}/${this.customerId}/Photo+request`
        );
      }
    },
    sendEmailToContractor() {
      let url = `/email/contractors/${this.itemId}?type=1&item_type=${this.itemType}`;
      window.sendEmail(url);
    },
    resetAddPhotoAndAttachmentModal(dropzoneType = 1) {
      EventBus.$emit("resetAddPhotoAndAttachmentModal", dropzoneType);
      $("#addPhotoAttachments_button_loop").show();
    },
  },
};
</script>

<style scoped>
#addAttachment_dropdown {
  border: none;
  width: 150px !important;
  height: 150px !important;
  color: #428bca !important;
  border-radius: 100%;
  background: none;
}

#addAttachment_dropdown:hover,
#addAttachment_dropdown:active,
#addAttachment_dropdown:checked {
  background: none !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 100%;
}

#addAttachment_dropdown i {
  /*position: relative;*/
  position: absolute;
  /*top: 50px;*/
  /*left: 60px;*/
}
#addAttachment_dropdown span {
  top: 40px;
  position: relative;
  /*top: 90px;*/
  /*position: relative;*/
  /*left: 35px;*/
}

.not-image-text {
  line-height: 150px;
  color: #428bca !important;
  font-size: 40px;
  font-weight: bold;
}
.overlay .overlay-text {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-decoration: none;
}

.product-gallery .img-responsive {
  height: 150px !important;
  width: 150px !important;
  margin-top: -10px !important;
}

.product-gallery {
  margin-top: -10px !important;
}

.see-more-size {
  background-color: #03a9f4;
  border-color: #03a9f4;
  color: #ffffff;
  padding: 6px 12px;
  height: auto;
  width: auto;
}
.hover-effect {
  width: 100%;
  height: 100%;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
  margin-top: 10px;
  margin-left: 10px;
}

.hover-effect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.hover-effect img {
  display: block;
  position: relative;
  -webkit-transition: all 0.4s linear;
  transition: all 0.4s linear;
}

.hover-effect h2 {
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 17px;
  background: rgba(0, 0, 0, 0.6);
  -webkit-transform: translatey(-100px);
  -ms-transform: translatey(-100px);
  transform: translatey(-100px);
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  padding: 10px;
}

.hover-effect a.info {
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  color: #fff;
  border: 1px solid #fff;
  background-color: transparent;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  margin: 50px 0 0;
  padding: 7px 14px;
}

.hover-effect a.info:hover {
  box-shadow: 0 0 5px #fff;
}

.hover-effect:hover img {
  -ms-transform: scale(1.2);
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}

.hover-effect:hover .overlay {
  opacity: 1;
  filter: alpha(opacity=100);
}

.hover-effect:hover h2,
.hover-effect:hover a.info {
  opacity: 1;
  filter: alpha(opacity=100);
  -ms-transform: translatey(0);
  -webkit-transform: translatey(0);
  transform: translatey(0);
}

.hover-effect:hover a.info {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
</style>
